import { useEffect, useState } from 'react';
import { useAuthStore } from '../stores/authStore';

export function useAuthBootstrap() {
  const { user, getMe, setMe, getRefreshToken, refresh } = useAuthStore();
  const [isAuthenticationChecked, setIsAuthenticationChecked] = useState(false);

  useEffect(() => {
    const handleInitialAuthCheck = () => {
      getRefreshToken().then((refreshToken) => {
        if (refreshToken) {
          refresh(refreshToken).then(() => {
            getMe().then(() => {
              setIsAuthenticationChecked(true);
            });
          });
        } else if (user === null && !refreshToken) {
          setMe(null).then(() => {
            setIsAuthenticationChecked(true);
          });
        } else {
          setIsAuthenticationChecked(true);
        }
      });
    };

    handleInitialAuthCheck();

    const tokenRefreshInterval = setInterval(async () => {
      const refreshToken = await getRefreshToken();
      if (refreshToken) {
        refresh(refreshToken);
      }
    }, 1000 * 60 * 30);

    return () => clearInterval(tokenRefreshInterval);
  }, [getMe, getRefreshToken, refresh, setMe]);

  return isAuthenticationChecked;
}
